/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorTicketLogDto } from '../../models/vendor-ticket-log-dto';

export interface VendorTicketLogControllerFindAll$Params {
}

export function vendorTicketLogControllerFindAll(http: HttpClient, rootUrl: string, params?: VendorTicketLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorTicketLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorTicketLogControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorTicketLogDto>;
    })
  );
}

vendorTicketLogControllerFindAll.PATH = '/api/vendor-ticket-log';
